import { Modal, Table } from "antd";

import { LectureFeedbackQuestionTable } from "../../../common-utils/LectureFeedback";

const DetailedFeedbackModal = ({
  isModalOpen = false,
  setIsModalOpen = () => {},
  responsesData = [],
  questionsData = []
}) => {
  const columns = [
    {
      title: "S No.",
      dataIndex: "index",
      key: "index"
    },
    {
      title: "Student Name",
      dataIndex: "userName",
      key: "userName"
    },
    {
      title: "Student Email",
      dataIndex: "userEmail",
      key: "userEmail"
    },
    {
      title: "Q1",
      dataIndex: "Q1",
      key: "Q1",
      sorter: (a, b) => a["Q1"] - b["Q1"]
    },
    {
      title: "Q2",
      dataIndex: "Q2",
      key: "Q2",
      sorter: (a, b) => a["Q2"] - b["Q2"]
    },
    {
      title: "Q3",
      dataIndex: "Q3",
      key: "Q3",
      sorter: (a, b) => a["Q3"] - b["Q3"]
    },
    {
      title: "Q4",
      dataIndex: "Q4",
      key: "Q4",
      sorter: (a, b) => a["Q4"] - b["Q4"]
    },
    {
      title: "Q5",
      dataIndex: "Q5",
      key: "Q5",
      sorter: (a, b) => a["Q5"] - b["Q5"]
    }
  ];
  return (
    <Modal
      title="Detailed Lecture Feedback"
      centered
      width={2000}
      open={isModalOpen}
      footer={[]}
      onOk={() => {
        setIsModalOpen(false);
      }}
      onCancel={() => {
        setIsModalOpen(false);
      }}
    >
      <LectureFeedbackQuestionTable questions={questionsData} />
      <Table
        columns={columns}
        dataSource={responsesData}
        bordered
        pagination={false}
        scroll={{ x: "max-content" }}
      />
    </Modal>
  );
};

export default DetailedFeedbackModal;
